// extracted by mini-css-extract-plugin
export default {"animation":"Skeleton_animation__1q9uf","shimmer":"Skeleton_shimmer__GWm0D","img":"Skeleton_img__AGbUm","title":"Skeleton_title__A6+dW","text":"Skeleton_text__8eP1p"};